// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"33357c35","69":"bb55c1b5","589":"a64a202a","760":"2681e666","775":"59a127fa","988":"e86632d9"}[chunkId] + ".chunk.js";
};